import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PasswordModal from './PasswordModal';
import CaseStudyNav from './CaseStudyNav';

// Gates a case-study route behind the same password check used on the
// homepage. Mirrors App.js's handleViewCaseStudy/handlePasswordSuccess flow
// so a direct link to /work/:slug is protected too, not just the homepage
// button that leads to it.
const CaseStudyGate = ({ projectName, children }) => {
  const navigate = useNavigate();
  const [isAuthed, setIsAuthed] = useState(
    () => sessionStorage.getItem('caseStudyAuth') === 'true'
  );
  const [isOpen, setIsOpen] = useState(!isAuthed);

  const handleSuccess = () => {
    setIsAuthed(true);
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    navigate('/');
  };

  const handleContactClick = () => {
    setIsOpen(false);
    navigate('/#contact');
  };

  if (!isAuthed) {
    return (
      <PasswordModal
        isOpen={isOpen}
        onClose={handleClose}
        onSuccess={handleSuccess}
        projectName={projectName}
        onContactClick={handleContactClick}
      />
    );
  }

  // The mobile nav is fixed to the top, so push the page down by its height
  // on small screens; desktop only gets the floating close button.
  return (
    <>
      <CaseStudyNav />
      <div className="pt-14 lg:pt-0">{children}</div>
    </>
  );
};

export default CaseStudyGate;
